<div class="apps-book-widget-multi-city-desktop">
  <div class="mc-desktop-container-row-1">
    <div class="mc-desktop-container-row-1__item trip-type-field">
      <mach-select
        id="trip-type-field"
        [title]="''"
        [content]="bookWidgetFields.tripTypesField.dropdownOptions"
        [disabled]="bookWidgetFields.tripTypesField.disable"
        (action)="
          onDropdownSelectionChange($event, bookWidgetFieldUpdateTypes.tripType)
        "
        [icon]="{
          alt: '',
          src: '/content/dam/delta-applications/sitewide/capability/flight-shop/images/multi-trip-icon.svg',
          show: true
        }"
        [ariaLabel]="bookWidgetAem.tripTypesField.tripTypeAriaLabel"
      ></mach-select>
    </div>
    <div class="mc-desktop-container-row-1__item passenger-field">
      <mach-select
        [title]="''"
        [content]="bookWidgetFields.passengerField.dropdownOptions"
        [disabled]="bookWidgetFields.passengerField.disable"
        (action)="
          onDropdownSelectionChange(
            $event,
            bookWidgetFieldUpdateTypes.passenger
          )
        "
        [icon]="{
          alt: bookWidgetAem.passengerField.passenger,
          src: '/content/dam/delta-applications/sitewide/capability/flight-shop/images/pax-icon.svg',
          show: true
        }"
        [ariaLabel]="bookWidgetAem.passengerField.passengerAriaLabel"
      ></mach-select>
    </div>
    <div class="mc-desktop-container-row-1__item find-flight-btn">
      <button
        machButton
        [buttonSize]="'large'"
        [buttonColor]="'primary'"
        [buttonOutlineColor]="'primary'"
        (click)="findFlight.emit()"
        id="findFilghtsCta"
      >
        {{ bookWidgetAem.searchBtn }}
      </button>
    </div>
  </div>
  <div class="mc-desktop-container-row-2">
    <div
      class="mc-desktop-flight-container"
      *ngFor="
        let airportItem of bookWidgetFields.airportsField.airports;
        let i = index
      "
    >
      <div class="mc-desktop-flight-index-label">
        {{ bookWidgetAem.airportsField.flight }} {{ i + 1 }}
      </div>
      <div class="mc-desktop-flight-info">
        <div class="mc-desktop-flight-route-picker">
          <idp-multicity-route-picker
            [routeIndex]="i"
            [routePickerContent]="{
              origin: {
                title:
                  bookWidgetFields.airportsField.airports[i].fromAirportcode ===
                  ''
                    ? bookWidgetAem.airportsField.from
                    : '',
                subtitle: bookWidgetAem.airportsField.yourOrigin
              },
              destination: {
                title:
                  bookWidgetFields.airportsField.airports[i].toAirportcode ===
                  ''
                    ? bookWidgetAem.airportsField.to
                    : '',
                subtitle: bookWidgetAem.airportsField.yourDestination
              },
              ariaLabels: {
                origin:
                  bookWidgetAem.airportsField.originAriaLabel +
                  (bookWidgetFields.airportsField.airports[i].fromAirportcode
                    .length
                    ? ' ' +
                      bookWidgetFields.airportsField.airports[i]
                        .fromAirportcode +
                      ', ' +
                      bookWidgetFields.airportsField.airports[i].fromCity
                    : ''),
                swapArrow: bookWidgetAem.airportsField.swapAriaLabel,
                departure:
                  bookWidgetAem.airportsField.departureAriaLabel +
                  (bookWidgetFields.airportsField.airports[i].toAirportcode
                    .length
                    ? ' ' +
                      bookWidgetFields.airportsField.airports[i].toAirportcode +
                      ', ' +
                      bookWidgetFields.airportsField.airports[i].toCity
                    : '')
              }
            }"
            [routePickerCities]="{
              destinationCode:
                bookWidgetFields.airportsField.airports[i].toAirportcode,
              destinationName:
                bookWidgetFields.airportsField.airports[i].toCity,
              destinationRegion: '',
              originCode:
                bookWidgetFields.airportsField.airports[i].fromAirportcode,
              originName: bookWidgetFields.airportsField.airports[i].fromCity,
              originRegion: ''
            }"
            [routePickerError]="
              bookWidgetFields.airportsField.fieldErrorInfo?.routePickerField
            "
            [recentSearchList]="recentSearchList"
            [savedSearchList]="savedSearchList"
            [searchModalTabs]="searchModalTabs"
            [isFullscreen]="isFullscreen"
            [predictiveSearchData]="predictiveSearchData"
            (swapClicked)="swapClicked.emit(i)"
            (searchModalTriggerClicked)="searchModalTriggerClicked.emit($event)"
            (searchModalEvent)="searchModalEvent.emit($event)"
          ></idp-multicity-route-picker>
        </div>
        <div class="mc-desktop-flight-date-picker dates-field">
          <idp-flight-date-picker
            [selectedTripType]="
              bookWidgetFields.tripTypesField.selectedTripType
            "
            [selectedRange]="bookWidgetFields.datesField.dates[i]"
            [bookWidgetAem]="bookWidgetAem"
            [datepickerConfig]="datepickerConfig"
            [fieldErrorInfo]="bookWidgetFields.datesField.fieldErrorInfo?.[i]"
            (action)="
              onDateSelectionChange(
                $event,
                bookWidgetFieldUpdateTypes.datesChange,
                i
              )
            "
          ></idp-flight-date-picker>
        </div>
        <div class="mc-desktop-flight-connection-picker">
          <idp-connection-picker
            class="connection-airport-picker"
            [routeIndex]="i"
            [placeholder]="bookWidgetAem.airportsField.connectionLabel"
            [connection]="{
              connectionCity: airportItem.connectionCity ?? '',
              connectionAirport: airportItem.connectionAirport ?? ''
            }"
            [recentSearchList]="recentSearchList"
            [savedSearchList]="savedSearchList"
            [searchModalTabs]="searchModalTabs"
            [connectionError]="
              bookWidgetFields.airportsField.fieldErrorInfo
                ?.connectionAirportField
            "
            [isFullscreen]="isFullscreen"
            [predictiveSearchData]="predictiveSearchData"
            [helpIconAriaLabel]="bookWidgetAem.helpIconAriaLabel"
            (searchModalTriggerClicked)="searchModalTriggerClicked.emit($event)"
            (searchModalEvent)="searchModalEvent.emit($event)"
            (showConnectionAirportInfoModal)="
              infoIconClickHandler(bookWidgetFieldInfoTypes.CONNECTION_AIRPORT)
            "
            (clearConnectionAirport)="clearConnectionAirport(i)"
          ></idp-connection-picker>
        </div>
      </div>
    </div>
  </div>
  <div class="mc-desktop-container-row-3">
    <a
      *ngIf="bookWidgetFields.airportsField.showAddFlightBtn"
      class="mc-desktop-container-row-3__item mc-desktop-add-flight"
      href="javascript:void(0);"
      [attr.aria-label]="bookWidgetAem.airportsField.addFlight"
      (click)="addFlight.emit()"
      machLink
    >
      <img
        src="/content/dam/delta-applications/sitewide/capability/flight-shop/images/plus.svg"
        alt=""
      />
      {{ bookWidgetAem.airportsField.addFlight }}
    </a>
    <a
      *ngIf="bookWidgetFields.airportsField.showRemoveFlightBtn"
      class="mc-desktop-container-row-3__item mc-desktop-remove-flight"
      href="javascript:void(0);"
      [attr.aria-label]="bookWidgetAem.airportsField.removeFlight"
      (click)="removeFlight.emit()"
      machLink
    >
      <img
        src="/content/dam/delta-applications/sitewide/capability/flight-shop/images/minus.svg"
        alt=""
      />
      {{ bookWidgetAem.airportsField.removeFlight }}
    </a>
  </div>
  <div class="mc-desktop-container-row-4">
    <div
      class="mc-desktop-container-row-4__item shop-miles-field"
      *ngIf="!bookWidgetFields.shopMilesField.hide"
    >
      <input
        machCheckbox
        type="checkbox"
        id="shopMiles"
        [disabled]="bookWidgetFields.shopMilesField.disable"
        [attr.aria-label]="bookWidgetAem.shopMilesField.shopWithMiles"
        [checked]="bookWidgetFields.shopMilesField.checked"
        (change)="
          onCheckBoxChange($event, bookWidgetFieldUpdateTypes.shopMiles)
        "
      />
      <label for="shopMiles" class="field-label">
        {{ bookWidgetAem.shopMilesField.shopWithMiles }}
      </label>
    </div>
    <div
      class="mc-desktop-container-row-4__item basic-fares-field"
      *ngIf="!bookWidgetFields.basicFaresField.hide"
    >
      <input
        machCheckbox
        type="checkbox"
        id="basicFaresField"
        [attr.aria-label]="bookWidgetAem.includeBasicField.includeBasic"
        [checked]="bookWidgetFields.basicFaresField.checked"
        [disabled]="bookWidgetFields.basicFaresField.disable"
        (change)="
          onCheckBoxChange($event, bookWidgetFieldUpdateTypes.basicFares)
        "
      />
      <label for="basicFaresField" class="field-label">
        {{ bookWidgetAem.includeBasicField.includeBasic }}
      </label>
    </div>
    <div
      class="mc-desktop-container-row-4__item refundable-fare-field"
      *ngIf="!bookWidgetFields.refundableFareField.hide"
    >
      <img
        class="refundable-fare-tooltip"
        src="/content/dam/delta-applications/sitewide/capability/flight-shop/images/alert-icon-help.svg"
        [attr.aria-label]="
          bookWidgetAem.refundableFareField.refundableOnly +
          ' ' +
          bookWidgetAem.helpIconAriaLabel
        "
        role="button"
        tabindex="0"
        (click)="
          infoIconClickHandler(bookWidgetFieldInfoTypes.REFUNDABLE_FARE_ONLY)
        "
        (keypress)="
          $event.key === 'Enter' &&
            infoIconClickHandler(bookWidgetFieldInfoTypes.REFUNDABLE_FARE_ONLY)
        "
      />
      <label for="refundableFares" class="field-label">
        {{ bookWidgetAem.refundableFareField.refundableOnly }}
      </label>
      <input
        machCheckbox
        type="checkbox"
        id="refundableFares"
        [disabled]="bookWidgetFields.refundableFareField.disable"
        [checked]="bookWidgetFields.refundableFareField.checked"
        [attr.aria-label]="bookWidgetAem.refundableFareField.refundableOnly"
        (change)="
          onCheckBoxChange($event, bookWidgetFieldUpdateTypes.refundableFare)
        "
      />
    </div>
  </div>
  <div class="mc-desktop-container-row-5">
    <div class="mc-desktop-container-row-5__item best-fare-meeting-container">
      <div
        class="best-fare-options-field"
        *ngIf="!bookWidgetFields.bestFareOptionsField.hide"
      >
        <idp-best-fare-options
          [bookWidgetAem]="bookWidgetAem"
          [bookWidgetFields]="bookWidgetFields"
          (bestFareOptionsChange)="
            onDropdownSelectionChange(
              $event,
              bookWidgetFieldUpdateTypes.bestFareOptions
            )
          "
        ></idp-best-fare-options>
      </div>
      <div
        class="meeting-event-code-field"
        *ngIf="!bookWidgetFields.meetingEventCodeField.hide"
      >
        <idp-meeting-event-code
          [bookWidgetAem]="bookWidgetAem"
          [bookWidgetFields]="bookWidgetFields"
          (meetingEventCodeChange)="
            onInputFieldChange(
              $event,
              bookWidgetFieldUpdateTypes.meetingEventCode
            )
          "
        ></idp-meeting-event-code>
      </div>
    </div>
    <div
      class="mc-desktop-container-row-5__item edocs-link"
      *ngIf="!bookWidgetFields.edocsLink.hide"
    >
      <a
        machLink
        [linkDisabled]="bookWidgetFields.edocsLink.disable"
        [linkSize]="'medium'"
        [attr.href]="bookWidgetFields.edocsLink.src"
        [attr.aria-label]="bookWidgetAem.edocsLink"
        [innerHTML]="bookWidgetAem.edocsLink"
      ></a>
    </div>
  </div>
</div>
